import { useCallback, useEffect, useState } from 'react';
import Api from '../../../services';
import { StationDispatchContext } from '../../../types/station-journey';

type StationContextState = {
  loading: boolean;
  data: StationDispatchContext | null;
  errorCode: string | null;
};

const apiErrorCode = (error: unknown) => {
  const { response } = error as { response?: { data?: { errors?: Array<{ message?: string }> } } };
  return response?.data?.errors?.[0]?.message || 'invalid_code';
};

export default function useStationContext(stationCode: string | undefined) {
  const [state, setState] = useState<StationContextState>({
    loading: true,
    data: null,
    errorCode: null,
  });
  const [refreshCount, setRefreshCount] = useState(0);

  const refresh = useCallback(() => {
    setRefreshCount((current) => current + 1);
  }, []);

  useEffect(() => {
    let active = true;

    if (!stationCode) {
      setState({ loading: false, data: null, errorCode: 'invalid_code' });
      return undefined;
    }

    setState({ loading: true, data: null, errorCode: null });
    Api.stations.getDispatchContext(stationCode)
      .then((data) => {
        if (active) {
          setState({
            loading: false,
            data,
            errorCode: data.dispatchable ? null : (data.error_code || 'dispatch_failed'),
          });
        }
      })
      .catch((error: unknown) => {
        if (active) {
          setState({ loading: false, data: null, errorCode: apiErrorCode(error) });
        }
      });

    return () => {
      active = false;
    };
  }, [refreshCount, stationCode]);

  return { ...state, refresh };
}
